import axios, { AxiosError } from "axios";
import { useMutation } from "react-query";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { deleteSuccessMessage } from "../../../Messages/successMessages";
import { rateAgreementUrls } from "../../../URL/ApplicationUrls";
import { MdmApiError } from "../../../Errors/MdmApiError";
import { apiErrorNotificationToast } from "../../../Errors/apiErrorNotificationToast";

export const useDeleteRateAgreement = (rateAgreementId: number | string | undefined) => {
  const navigate = useNavigate();

  return useMutation({
    mutationFn: async (id: number | string | undefined) => {
      await axios.delete(rateAgreementUrls.apiUrlForRateAgreementWithId(id));
    },
    onSuccess: async () => {
      toast.success(deleteSuccessMessage(rateAgreementId, "Rate Agreement"));
      navigate(rateAgreementUrls.base.uiPath);
    },
    onError: (error: AxiosError<MdmApiError>) => {
      apiErrorNotificationToast(error);
    },
  });
};
